var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCk = function SvgIconCk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.968 12H12v-.031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.262V0h-.002C5.371.002 0 5.374 0 12.001h6.26V8.475l3.526 3.526h2.182l.032-.032V9.787L8.474 6.262z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.071 1.564A12.06 12.06 0 0 0 1.565 6.07V12h3.13V4.694H12v-3.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.523 7.736 6.26H6.261L12 12z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.175 12 .222.683h.718l-.581.422.222.684-.581-.422-.582.422.223-.684-.582-.422h.719zM13.223 13.223l.64.326.508-.508-.112.71.64.326-.71.112-.112.71-.326-.64-.71.112.508-.508zM12 16.173l.683-.222v-.718l.422.58.684-.221-.422.581.422.581-.684-.222-.422.581v-.718zM13.223 19.125l.326-.64-.508-.508.71.113.326-.64.112.71.71.111-.64.327.112.71-.508-.509zM16.174 20.348l-.222-.683h-.719l.582-.422-.222-.683.58.422.582-.422-.222.683.581.422h-.718zM19.125 19.126l-.64-.327-.508.509.112-.71-.64-.326.71-.113.112-.71.326.64.71-.111-.508.507zM20.348 16.173l-.683.222v.718l-.422-.58-.683.221.422-.581-.422-.581.683.222.422-.581v.718zM19.125 13.223l-.326.64.508.508-.71-.113-.326.64-.112-.709-.71-.112.64-.326-.112-.71.508.508z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconCk;